module.exports = __webpack_public_path__ + "images/header-logo-2x.01ef898811a879595cea.png";